import { render, staticRenderFns } from "./DpdParcelShop.vue?vue&type=template&id=dadc54ae&scoped=true&"
import script from "./DpdParcelShop.vue?vue&type=script&lang=js&"
export * from "./DpdParcelShop.vue?vue&type=script&lang=js&"
import style0 from "./DpdParcelShop.vue?vue&type=style&index=0&id=dadc54ae&lang=scss&scoped=scoped&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dadc54ae",
  null
  
)

export default component.exports